import { Money } from '@core/Components/Text/Money'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ComboLookup, costCalculator } from './calculator'
import {
  HeaderStyled,
  FavouriteNumbersSection,
  PotLuckNumbersStyled,
  PotLuckNumbersButtonStyled,
  FavouriteNumbersFlex,
  PotLuckNumberButtonStyled,
  PotLuckNumberCostStyled,
} from './FavouriteNumbers.styles'
import { FavouriteNumbersBetSummary } from './FavouriteNumbersBetSummary'
import { HeaderWithLoadingIndicator } from './HeaderWithLoader'
import { NumberButtons } from './NumberSelection'
import { PoolSelection } from './PoolSelection'
import { clearSelections, setNumberOfBets, setPotLuckNumbers } from './Store'
import { selectPotluckBets, selectGameOne } from './Store/selectors'

export const PotLuckTab = (): JSX.Element => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    return () => {
      dispatch(clearSelections())
    }
  }, [dispatch])

  return (
    <div style={{ marginTop: '1em' }} data-testid='pot-luck'>
      <HeaderWithLoadingIndicator title='SELECT NUMBERS'></HeaderWithLoadingIndicator>
      <PotLuckNumbers />
      <HeaderStyled data-tid-select-pools-header=''>SELECT POOL DATES</HeaderStyled>
      <PoolSelection />
      <HeaderStyled data-tid-num-bets-header=''>NUMBER OF BETS</HeaderStyled>
      <NumberOfBets />
      <HeaderStyled data-tid-bet-summary-header=''>BET SUMMARY</HeaderStyled>
      <FavouriteNumbersBetSummary mode='potLuck' />
    </div>
  )
}

const NumberOfBets = (): JSX.Element => {
  const dispatch = useDispatch()
  const potLuckBets = useSelector(selectPotluckBets)

  return (
    <FavouriteNumbersSection>
      <NumberButtons
        numbers={10}
        selectedNumbers={[potLuckBets]}
        onClickHandler={(number: number) => {
          dispatch(setNumberOfBets(number))
        }}
      />
    </FavouriteNumbersSection>
  )
}

const PotLuckNumbers = (): JSX.Element => {
  const dispatch = useDispatch()
  const gameOne = useSelector(selectGameOne)

  React.useEffect(() => {
    if (gameOne.length === 0) {
      dispatch(setPotLuckNumbers(7))
    }
  }, [gameOne, gameOne.length, dispatch])

  return (
    <PotLuckNumbersStyled data-testid='potluck-numbers'>
      {Object.keys(ComboLookup).map(key => {
        const numbers = Number.parseInt(key)
        const isSelected = gameOne.length > 0 && gameOne[0] === numbers
        return (
          <PotLuckNumbersButtonStyled
            data-tid-potluck-numbers=''
            key={`numbers-${numbers}`}
            onClick={() => dispatch(setPotLuckNumbers(numbers))}
            color={isSelected ? 'dark' : 'secondary'}
          >
            <FavouriteNumbersFlex>
              <PotLuckNumberButtonStyled>{numbers}</PotLuckNumberButtonStyled>
              <PotLuckNumberCostStyled>
                <Money amount={costCalculator(numbers ?? 0)} />
              </PotLuckNumberCostStyled>
            </FavouriteNumbersFlex>
          </PotLuckNumbersButtonStyled>
        )
      })}
    </PotLuckNumbersStyled>
  )
}
